import { render, staticRenderFns } from "./ModificationFormationReconnue.vue?vue&type=template&id=ee31fe96"
import script from "./ModificationFormationReconnue.vue?vue&type=script&lang=js"
export * from "./ModificationFormationReconnue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports